<template>
  <div class="layout-box">
    <LayoutHeader headtitle="行业知识"></LayoutHeader>
    <div class="secondary-content">
      <GoBack></GoBack>
      <div class="experts-title">
        <div class="bread-crumb-nav">当前位置：<a @click="$router.go(-1)">首页</a> > 行业知识</div>
      </div>
      <ul class="experts-list clear">
        <li v-for="(item,index) in datas" :key="index">
          <a :href='item.url' target="_blank">
            <div class="fb-time">{{ item.tiem1 }}<span>{{ item.time2 }}</span></div>
            <div>
              <h3>{{ item.titles }}</h3>
              <p>{{item.dcs}}</p>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "../layout/layout-header2";
import GoBack from "../layout/layout-goback";
export default {
  name: 'IndustryKnowledge',
  components:{
    LayoutHeader,
    GoBack
  },
  data () {
    return {
      datas:[
        {tiem1:'13',time2:'2022-08',titles:'我国绿色纺织品的现状及发展趋势',url:'/Indunowledgedetails?id=11',dcs:'摘要：介绍了国际上绿色纺织品的发展动态及国内绿色纺织品的发展现状,分析了绿色纺织品对纤维原料、染整、经营等方面的要求，并指出了国内绿色纺织品的发展趋势，认为我国应该从树立绿色经营观念入手，开发绿色资源，研制绿色纺织品，并制定绿色价格，实施绿色经营。'},
        {tiem1:'04',time2:'2022-07',titles:'提高大比例涤纶混纺纱质量的工艺措施',url:'/Indunowledgedetails?id=10',dcs:'前几年，我公司在全国纺织行业不景气的情况下，靠给南方某企业来料加工大比例涤纶混纺针织纱T/R 98/02  13 tex，T/R 95/05 13 tex，使得企业得以正常运行生产。其中T/R98/02 13tex占我公司新纺分厂锭数的52%，T/C95/05 13tex占老纺分厂锭数的36%，这里主要介绍生产T/R 98/02 13 tex时所遇到的几个问题及解决措施'},
        {tiem1:'28',time2:'2021-09',titles:'你需要的异形涤纶知识全在这里了！',url:'https://forum.ccf.com.cn/fiber/knowledge_detail.php?id=37',dcs:'涤纶纤维 作为应用最广泛的化学纤维，其具有良好的成纤性能和机械性能，强度高、耐光、耐热和耐酸碱性好，具有良好的加工性和易纺性，可纯纺、混纺或交织。涤纶面料耐洗耐磨、免烫抗皱，在服装、家纺、装饰和产业用等领域被广泛应用。然而，涤纶纤维也存在吸湿性差、织物不吸汗、穿着有闷热感、防静电能力差和易沾污灰尘等缺点，因此大大制约了涤纶纤维的应用于发展。'},
        {tiem1:'30',time2:'2021-07',titles:'12种合成纤维的分类及简介',url:'https://forum.ccf.com.cn/fiber/knowledge_detail.php?id=36',dcs:'在合成纤维的制造过程中,纺丝流体(熔体或溶液)经纺丝成形和后加工工序后,得到的长度以千米计的纤维称为长丝。长丝包括单丝、复丝和帘线丝。'},
        {tiem1:'30',time2:'2021-07',titles:'涤纶针织物的染色技术',url:'https://forum.ccf.com.cn/fiber/knowledge_detail.php?id=35',dcs:'混纺织物是化学纤维与其它棉毛、丝、麻等到天然纤维混合纺纱织成的纺织产品，既有涤纶的风格又有棉织物的长处，如涤棉布、涤毛华达呢等。混纺分为毛粘混纺、羊兔毛绲纺、TR面料、高密NC布、3M防水摩丝布、天丝(TENCE...'},
        {tiem1:'09',time2:'2021-07',titles:'如何鉴别再生涤纶？',url:'https://forum.ccf.com.cn/fiber/knowledge_detail.php?id=34',dcs:'2021年2月1日实施的国家标准GB/T 39026-2020《循环再利用聚酯（PET）纤维鉴别方法》填补了该领域的国内、外空白，为国家制定相关政策提供了技术支持与保障。'},
        {tiem1:'09',time2:'2021-07',titles:'涤纶与锦纶区别知多少？',url:'https://forum.ccf.com.cn/fiber/knowledge_detail.php?id=33',dcs:'一、涤纶与锦纶区别，涤纶---聚脂纤维又称POLYESTER，特性是良好的透气性和排湿性。还有较强的抗酸碱性，抗紫外线的能力。锦纶---尼龙又称Nylon，聚酰胺纤维。优点是高强度、高耐磨性、高抗化学性及良好的抗变形性，...'},
        {tiem1:'06',time2:'2021-05',titles:'涤纶的特点及其混纺的优越性',url:'https://forum.ccf.com.cn/fiber/knowledge_detail.php?id=32',dcs:'涤纶 是合成纤维中的一个重要品种，是我国聚酯纤维的商品名称。是以精对苯二甲酸（PTA）或对苯二甲酸二甲酯 （DMT）和乙二醇（MEG）为原料经酯化或酯交换和缩聚反应而制得的成纤高聚物--聚对苯二甲酸乙二醇酯（PET）...'},
        {tiem1:'06',time2:'2021-05',titles:'涤纶POY、DTY、FDY的区别',url:'https://forum.ccf.com.cn/fiber/knowledge_detail.php?id=31',dcs:'涤纶作为纺织品的常见的纤维，一直都是面料市场最热门的品类之一，市面上涤纶面料品类繁多，但是，你真的了解它吗？'},
        {tiem1:'30',time2:'2021-04',titles:'浅谈纺织纤维的基本性能',url:'https://forum.ccf.com.cn/fiber/knowledge_detail.php?id=30',dcs:'　纺织纤维放在空气中，会不断地和空气进行水汽的交换，即纺织纤维不断地吸收空气中的水汽，同时也不断地向空气中放出水汽。纺织纤维吸收或放出水汽的性能称为纤维的吸湿性。吸湿性是纺织纤维的重要物理性能之...'},
        {tiem1:'30',time2:'2021-04',titles:'涤纶的前世今生',url:'https://forum.ccf.com.cn/fiber/knowledge_detail.php?id=29',dcs:'涤纶是合成纤维中的一个重要品种，是我国聚酯纤维的商品名称。它是以精对苯二甲酸（PTA）或对苯二甲酸二甲酯（DMT）和乙二醇（EG）为原料经酯化或酯交换和缩聚反应而制得的成纤高聚物——聚对苯二甲酸乙二醇酯（PET）...'},
        {tiem1:'30',time2:'2021-04',titles:'涤纶长丝的品质标准',url:'https://forum.ccf.com.cn/fiber/knowledge_detail.php?id=28',dcs:'一、物理指标\n' +
            '\n' +
            '1　线密度\n' +
            '\n' +
            '    线密度是表示长丝粗细程度的指标，是最基本的品质指标。一般用分特(dtex)表示，也可用特克斯(tex)表示。长丝的线密度包括复丝线密度和单丝线密度。如167dtex/30F长丝的复丝线密度为167dtex，单丝线密度为5.6dtex。\n' +
            '\n' +
            '2　断裂强度\n' +
            '\n' +
            '    断裂强度是指单位分特的丝线被拉断所承担的外力。断裂强度高，在加工过程中不易断头、绕辊。但断裂强度太高，纤维刚性增加，纱线和织物的手感变差。'},
        {tiem1:'01',time2:'2021-02',titles:'复合芳香涤纶纤维纱及其产品的研制',url:'/Indunowledgedetails?id=12',dcs:'摘要：对复合芳香涤纶纤维的性能与纺纱特点进行了测试分析，设计出了适合于芳香涤纶纤维性能特点的纺纱工艺，并开发出了复合芳香涤纶纯纺纱、混纺纱及其织物。'},
        {tiem1:'10',time2:'2020-12',titles:'细特涤纶竹纤维混纺纱的品种开发',url:'/Indunowledgedetails?id=13',dcs:'摘要：为了顺利纺制细特涤纶纤维、普通棉型涤纶纤维和竹纤维三组分复合细号纱线，从客户的质量要求出发，对各工序影响质量的因素进行了分析和研究，重点采取原料选配，清梳工序开松梳理，并条工序混纺比准确和并合均匀，粗纱工序优化工艺配置，解决粗纱疵点及“大肚纱”问题，细纱工序减少毛羽和断关，络筒工序控制毛羽和棉结增长率等措施，最终成纱质量满足了客户要求。'},
      ]
    }
  },
  methods: {

  }
}
</script>

<style scoped>
.layout-box {
  position: relative;
  width: 100%;
  height: calc(100% - 170px);
  padding-top: 170px;
  overflow: auto;
  background: url("../../assets/erj_bj.fw.png");
}

.layout-box::-webkit-scrollbar{
  display: none;
}

.secondary-content{
  width: 1100px;
  margin: 0 auto;
  position: relative;
  background: #0A47B6;
}

.experts-title{
  width:100%;
  height: 59px;
  background-image: linear-gradient(rgba(239,243,254,.2),rgba(197,210,250,.48));
}

.bread-crumb-nav{
  font-size: 16px;
  color: #fff;
  font-family: 微软雅黑;
  line-height: 59px;
  padding-left: 20px;
}

.bread-crumb-nav a{
  cursor: pointer;
  color: #fff;
  text-decoration: none;
}
.bread-crumb-nav a:hover{
  text-decoration: underline;
  font-weight: bold;
}

.experts-list{
  padding: 30px 0 0 18px;
}


.experts-list li{
  width: 488px;
  height: 162px;
  padding: 10px;
  margin: 0 12px 25px 12px;
  background: #E3E9F6;
  cursor: pointer;
  box-shadow:0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  float: left;
}

.experts-list li:hover{
  background: #fff;
  border: 2px solid #2095EF;
  padding: 8px;
}

.experts-list a{
  text-decoration: none;
  display: flex;
  justify-content: space-between;
}

.experts-list h3{
  line-height: 180%;
  color: #333;
}

.experts-list p{
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space:normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-break: break-all;
  -webkit-line-clamp: 6;
}

.fb-time{
  width: 100px;
  height: 100px;
  background: #FFFFFF;
  font-size: 32px;
  text-align: center;
  line-height: 50px;
  color: #1e63c1;
  flex-shrink:0;
  margin-right: 15px;
}

.fb-time span{
  display: inline-block;
  width: 100%;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  color: #fff;
  background: #1e63c1;
}

</style>




// WEBPACK FOOTER //
// src/views/secondary/secondary-Industryknowledge-list.vue